import React from 'react';
import Phone from '../assets/images/phoneicon.svg';

export default () => {
  return <img src={Phone} alt="" />;
};
